export default [
  {
    path: '/contratti/gestione-contratti',
    name: 'gestione-contratti',
    component: () => import('@/views/contratti/PaginaContratti.vue'),
    meta: {
      resource: 'contratti',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contratti',
        },
        {
          text: 'Gestione Contratti',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contratti/gestione-contratti',
    name: 'riepiloghi-contratti',
    component: () => import('@/views/contratti/PaginaRiepiloghiContratti.vue'),
    meta: {
      resource: 'gestione-contratti',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contratti',
        },
        {
          text: 'Riepilogo Contratti',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contratti/pagamenti-contratti',
    name: 'pagamenti-contratti',
    component: () => import('@/views/contratti/PaginaPagamentiContratti.vue'),
    meta: {
      resource: 'contratti-full',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contratti',
        },
        {
          text: 'Pagamenti Contratti',
          active: true,
        },
      ],
    },
  },
]
